import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Loader from 'components/Loader'
import DashboardHeader from 'reports/dashboard/DashboardHeader'
import DashboardTree from 'reports/dashboard/DashboardTree'
import ReportGraph from 'components/ReportGraph'
import { selectPlant } from 'reports/dashboard/selectors'
import { reportShape } from 'reports/dashboard/shapes'
import { Characters } from 'lib/const'
import { StickyContainer } from 'react-sticky'

const Dashboard = ({ isLoaded, plant }) => {
  const { report } = plant
  if (isLoaded) {
    return (
      <StickyContainer>
        <DashboardHeader />

        <div className='report__graphs'>
          <ReportGraph values={report.production} character={Characters.PRODUCTION} />
          <ReportGraph values={report.stoppagePlanned} character={Characters.STOPPAGE_PLANNED} />
          <ReportGraph values={report.stoppageUnplanned} character={Characters.STOPPAGE_UNPLANNED} />
          <ReportGraph values={report.stoppagePrototyping} character={Characters.STOPPAGE_PROTOTYPING} />
          <ReportGraph values={report.scrap} character={Characters.SCRAP} />
        </div>

        <DashboardTree />
      </StickyContainer>
    )
  } else {
    return <Loader full />
  }
}

Dashboard.propTypes = {
  isLoaded: PropTypes.bool.isRequired,
  plant: PropTypes.shape({
    name: PropTypes.string,
    report: reportShape
  }).isRequired
}

const mapStateToProps = (state) => ({
  isLoaded: state.init.isFinished,
  plant: selectPlant(state)
})

export default connect(mapStateToProps)(Dashboard)
